import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UigLoginFormModule } from './uig-login/uig-login-form/uig-login-form.module';
import { UigForgotPasswordModule } from './uig-forgot-password/uig-forgot-password.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    UigLoginFormModule,
    UigForgotPasswordModule
  ]
})
export class UigAuthModule { }
